import { getRequestedAmount } from "../../utils/utils";

export const getActiveUserId = (user?: any): string => {
  if (!user) return "guest";

  if (
    user.user_id !== null &&
    user.user_id !== undefined &&
    user.user_id !== ""
  ) {
    return String(user.user_id).trim();
  }

  if (user.id !== null && user.id !== undefined && user.id !== "") {
    return String(user.id).trim();
  }

  return "guest";
};

export const computeCartItemData = (
  plan: any,
  isAtm = false,
  type: string,
  additionalInputValue?: string | number,
) => {
  const isFixed = plan?.price_type === "fixed";
  const amountRequested = getRequestedAmount(
    type,
    additionalInputValue,
    !isFixed,
  );

  const rawWalletPrice = isFixed
    ? Number(plan?.wallet_price ?? 0)
    : (Number(plan?.wallet_price ?? 0) * amountRequested) / 100;

  const discountRaw = Number(plan?.plan_discount ?? 0);
  const walletPriceRaw = Number(plan?.wallet_price ?? 0);
  const hasDiscount = discountRaw > 0 && discountRaw > walletPriceRaw;

  let rawOriginalPrice = rawWalletPrice;
  if (hasDiscount) {
    rawOriginalPrice = isFixed
      ? discountRaw
      : (discountRaw * amountRequested) / 100;
  }

  const rawUnitDiscount = hasDiscount
    ? Math.max(0, rawOriginalPrice - rawWalletPrice)
    : 0;

  const discountPercent = hasDiscount
    ? ((discountRaw - walletPriceRaw) / discountRaw) * 100
    : 0;

  const atm_price = Number(plan?.atm_price ?? plan?.wallet_price ?? 0);
  const currentActivePrice = isAtm ? rawWalletPrice : atm_price;

  const rawBonusAmount =
    plan?.price_type === "percent"
      ? (Number(plan?.point_bonus ?? 0) / 100) * currentActivePrice
      : Number(plan?.point_bonus ?? plan?.bonus_points ?? plan?.points ?? 0);

  return {
    rawWalletPrice,
    rawOriginalPrice,
    rawBonusAmount,
    discountPercent,
    rawUnitDiscount,
    isFixed,
  };
};
